/*jslint browser: true */
/*global angular */

(function () {
    'use strict';

    angular.module('sky.wait', ['sky.wait.directive', 'sky.wait.factory']);
}());